import { useCurrentUser } from 'store/main/hooks';

export function useHasGradProgram(): boolean {
  const currentUser = useCurrentUser();

  return (
    currentUser &&
    currentUser.orgs &&
    currentUser.orgs.some((org) => org.hasGradProgram)
  );
}
